import React, {useEffect} from 'react';
import {Link} from 'react-router-dom';

export const DashboardHeader = React.memo(() => {
    useEffect(() => {
        document.title = 'WaterGraph Admin';

        const favicon = document.querySelector('link[rel="icon"]');
        if (favicon instanceof HTMLLinkElement) {
            favicon.href = '/administrator.png';
        } else {

            const link = document.createElement('link');
            link.rel = 'icon';
            link.href = '/client-favicon.ico';
            document.head.appendChild(link);
        }

    }, []);
  return (
    <header
      id="dashboard-header"
      className="flex w-screen items-center justify-between gap-3 border-b border-solid border-blue-400 bg-slate-50 pr-3 text-sky-700">
      <span
        className="my-auto ml-3 whitespace-nowrap text-xl font-semibold md:text-4xl"
        style={{
          font: 'Noto Sans',
        }}>
        WATERGRAPH管理
      </span>
      <Link
        to="/map"
        className="shrink-0 rounded-lg border border-blue-700 px-3 py-2 text-sm font-medium text-blue-700 hover:bg-blue-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700">
        Mapへ
      </Link>
    </header>
  );
});
